$(document).ready(function(){

    //Запрос на сервер
    async function changeCart(url) {
        const res = await fetch(url, {
            method: 'GET',
        })
        return res.json()
    }

    //Скрыть/показать количество товара в корзине
    function showProductCount(count) {
        const countValue = $('.menu__goods-value');

        countValue.html(count)

        if (count > 0) {
            countValue.addClass('menu__goods-value--active')
        } else {
            countValue.removeClass('menu__goods-value--active')
        }
    }

    //Обновление списка заказанных товаров
    function updateProductList(count, totalPrice, productList) {
        const goodsBlock = $('.js-goods-popup');
        const goodsBlockList = $('.js-goods-added');
        const goodsTotalCount = $('.goods__total-count');
        const goodsTotalPrice = $('.goods__total-price');

        if (productList) {
            goodsBlockList.html(productList);
        }

        if (totalPrice) {
            goodsTotalCount.text(count)
            goodsTotalPrice.text(totalPrice)
        }

        console.log(444, count)

        if (count > 0) {
            goodsBlock.addClass('goods--active')
        } else {
            goodsBlock.removeClass('goods--active')
        }
    }

    //Первый вызов при загрузке страницы
    changeCart(`/ajax/get-cart`)
        .then(res => {

            showProductCount(res.cart.count)
            updateProductList(res.cart.count, res.cart.total, res.cart.html)
        })

    //Обработка клика добавления/удаления товаров
    // const addButton = $('.js-goods-add');
    // const deleteButton = $('.js-goods-delete');

    $(document).on('click', '.js-goods-add', function () {
        const productId = $(this).attr('data-goods-id')

        changeCart(`/ajax/add-to-cart?id=${productId}`)
            .then(res => {

                showProductCount(res.cart.count)
                updateProductList(res.cart.count, res.cart.total, res.cart.html)
            })
    });

    $(document).on('click', '.js-goods-delete', function () {
        const productId = $(this).attr('data-goods-id')

        changeCart(`/ajax/remove-from-cart?id=${productId}`)
            .then(res => {
                showProductCount(res.cart.count)
                updateProductList(res.cart.count, res.cart.total, res.cart.html)
            })
    });

    //Очистка корзины
    const cleanButton = $('.button--action-clean');

    cleanButton.on('click', function () {

        changeCart(`/ajax/clear-cart`)
            .then(res => {

                showProductCount(res.cart.count)
                updateProductList(res.cart.count)
            })
    });
});
